export default "__VITE_ASSET__32ee85f7__"